import * as types from './actionTypes';
import PrivateAPIResource from "../services/PrivateAPIResource";

export function getSettingsSuccess(settings) {
    return {type: types.GET_SETTINGS_SUCCESS, settings};
}

export function updateSettingsSuccess(settings) {
    return {type: types.UPDATE_SETTINGS_SUCCESS, settings};
}

export function getSettingSuccess(setting) {
    return {type: types.GET_SETTING_SUCCESS, setting};
}

export function getSettings() {
    return function (dispatch) {
        return PrivateAPIResource.get('settings').then(settings => {
            dispatch(getSettingsSuccess(settings));
        }).catch(error => {
                throw error;
            });
    }
}

export function updateSettings(key, data) {
    return function (dispatch, getState) {
        return PrivateAPIResource.update('settings',key, data).then(settings => {
            dispatch(updateSettingsSuccess(settings));
        }).catch(error => {
            throw error;
        })
    }
}

export function getSetting(name) {
    return function (dispatch, getState) {
        return PrivateAPIResource.get('settings', name).then((setting) => {
            dispatch(getSettingSuccess(setting));
        }).catch(error => {
            throw error;
        })
    }
}


// WEBPACK FOOTER //
// ./web/src/actions/settingsActions.js